import { render, staticRenderFns } from "./JoinLogistics.vue?vue&type=template&id=a3c5ac70&scoped=true&"
import script from "./JoinLogistics.vue?vue&type=script&lang=js&"
export * from "./JoinLogistics.vue?vue&type=script&lang=js&"
import style0 from "./JoinLogistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./JoinLogistics.vue?vue&type=style&index=1&id=a3c5ac70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c5ac70",
  null
  
)

export default component.exports